import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, renewToken, setTokenNExp } from "../../redux/slices/auth";
import BigNumber from "bignumber.js";
import { ToastContainer, toast } from "react-toastify";
import { ServerURL } from "../../redux/Server";
import PegaGadget from "../PegaGadget";

const Mashup = () => {
  const dispatch = useDispatch();
  const [nonCommitteeToken, setNonCommitteeToken] = useState("");
  const [nonCommitteeTokenExp, setNonCommitteeTokenExp] = useState("");
  const [loadingLogout, setLoadingLogout] = useState(false);
  const [twoMinutesBeforeApiTimestamp, setTwoMinutesBeforeApiTimestamp] =
    useState(null);
  const [intervalId, setIntervalId] = useState(null);
  const auth = useSelector(state => state.auth);
  const { token, tokenExp } = auth;
  const navigate = useNavigate();

  const showErrorToast = () => {
    toast.error("فشل تسجيل الخروج، برجاء المحاولة مرة أخرى", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      rtl: true,
      theme: "colored",
    });
  };

  //Handle Logout
  useEffect(() => {
    const params = new URLSearchParams(window?.location.search);
    setLoadingLogout(false);
    if (params.size > 0) {
      const logoutReason = params.get("logoutReason");
      const userType = params.get("userType");
      const logoutStatus = params.get("logoutSuccess");
      if (logoutReason && logoutReason.length > 0) {
        setLoadingLogout(true);
        if (
          userType === "CITIZEN" ||
          userType === "RESIDENT" ||
          userType === "NON_RESIDENT" ||
          userType === "LEGAL_REPRSENTATIVE" ||
          userType === "LEGAL_AGENT"
        ) {
          dispatch(logout());
          setTimeout(() => {
            setLoadingLogout(false);
            /* const currentUrl = window?.location.href;
            const urlWithoutMashup = currentUrl.replace("/mashup", "");
            window.location.href = urlWithoutMashup; */
            navigate("/", { replace: true });
          }, 1000);
        } else {
          window.location.replace(`${ServerURL}/NafathRestApi/saml/logout`);
        }
      }
      if (logoutStatus && logoutStatus === "true") {
        setLoadingLogout(true);
        navigate("/", { replace: true });
        dispatch(logout());
        setTimeout(() => {
          setLoadingLogout(false);
          /* const currentUrl = window?.location.href;
          const urlWithoutMashup = currentUrl.replace("/mashup", "");
          window.location.href = urlWithoutMashup; */
          //navigate("/", { replace: true });
        }, 1000);
      }
      if (logoutStatus && logoutStatus === "false") {
        const pathName = window.location.pathname;
        const redirectTo = pathName.replace(
          `?logoutSuccess=${logoutStatus}`,
          "",
        );
        window.history.replaceState(null, "", redirectTo);
        setTimeout(() => {
          showErrorToast();
        }, 1000);
      }
    }
  }, [dispatch, navigate, loadingLogout]);

  // Handle Token and Remove local storage on tab close
  useEffect(() => {
    if (token) {
      localStorage.setItem("nonCommitteeToken", token);
      setNonCommitteeToken(token);
      localStorage.setItem("initialized", "true");
    }
    if (tokenExp) {
      localStorage.setItem("nonCommitteeTokenExp", tokenExp);
      setNonCommitteeTokenExp(tokenExp);
    }
    const params = new URLSearchParams(window?.location.search);
    if (params.size > 0) {
      const currentToken = params.get("jwtToken");
      const tokenExpiry = params.get("jwtExp");

      if (
        currentToken &&
        currentToken !== "null" &&
        tokenExpiry &&
        tokenExpiry !== "null"
      ) {
        // Dispatch action to set token and expiry
        dispatch(setTokenNExp({ jwtToken: currentToken, jwtExp: tokenExpiry }));

        // Store token and expiry in local storage
        localStorage.setItem("nonCommitteeToken", currentToken);
        localStorage.setItem("nonCommitteeTokenExp", tokenExpiry);
        localStorage.setItem("initialized", "true");

        // Update state
        setNonCommitteeToken(currentToken);
        setNonCommitteeTokenExp(tokenExpiry);

        // Clean the URL by removing query parameters
        const pathName = window?.location.pathname;
        const redirectTo = pathName.replace(
          `?statusCode=I000000&jwtToken=${currentToken}&jwtExp=${tokenExpiry}`,
          "",
        );
        window.history.replaceState(null, "", redirectTo);
      } else if (currentToken === "null" || tokenExpiry === "null") {
        localStorage.removeItem("nonCommitteeToken");
        localStorage.removeItem("nonCommitteeTokenExp");
        navigate(`/?message="Authentication Failed"`);
      } else {
        // Check local storage for existing token
        const storedToken = localStorage.getItem("nonCommitteeToken");
        const storedTokenExp = localStorage.getItem("nonCommitteeTokenExp");
        if (storedToken && storedTokenExp) {
          setNonCommitteeToken(storedToken);
          setNonCommitteeTokenExp(storedTokenExp);
        } else {
          navigate("/", { replace: true });
        }
      }
    }
  }, [navigate, token, tokenExp, dispatch]);

  // useEffect(() => {
  //   const inialized = localStorage.getItem("initialized");
  //   const handleUnload = () => {
  //     if (document.visibilityState === "hidden" && inialized === null) {
  //       localStorage.removeItem("nonCommitteeToken");
  //       localStorage.removeItem("nonCommitteeTokenExp");
  //     }
  //   };
  //   document.addEventListener("visibilitychange", handleUnload);
  //   window.addEventListener("unload", handleUnload);
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleUnload);
  //     window.removeEventListener("unload", handleUnload);
  //   };
  // }, []);

  useEffect(() => {
    const initialized = localStorage.getItem("initialized");
    const timer = setTimeout(() => {
      if (initialized && initialized === "true") {
        localStorage.removeItem("initialized");
      }
    }, 100);

    // Clean up the timer when the component is unmounted
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const currentToken = localStorage.getItem("nonCommitteeToken");
    const timer = setTimeout(() => {
      if (!currentToken) {
        navigate("/", { replace: true });
      }
    }, 1500);

    // Clean up the timer when the component is unmounted
    return () => clearTimeout(timer);
  }, [navigate, token]);

  useEffect(() => {
    if (nonCommitteeTokenExp) {
      const apiTimestampBN = new BigNumber(nonCommitteeTokenExp);
      const twoMinutesInMs = new BigNumber(2 * 60 * 1000);
      const twoMinutesBeforeTimestamp = apiTimestampBN
        .minus(twoMinutesInMs)
        .toNumber();
      setTwoMinutesBeforeApiTimestamp(twoMinutesBeforeTimestamp);
      const id = setInterval(() => {
        const currentTime = new Date().getTime();
        if (currentTime >= twoMinutesBeforeApiTimestamp) {
          dispatch(renewToken({ jwt: nonCommitteeToken }));
          clearInterval(id);
          setIntervalId(null);
        }
      }, 1000);
      setIntervalId(id);
    }
  }, [
    nonCommitteeTokenExp,
    dispatch,
    nonCommitteeToken,
    twoMinutesBeforeApiTimestamp,
  ]);

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [intervalId]);

  if (loadingLogout) {
    return (
      <div className="loading-logout show">
        <div className="lds-roller">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  } else {
    return (
      <Fragment>
        <ToastContainer />
        <PegaGadget />
      </Fragment>
    );
  }
};

export default Mashup;
